import { useEffect, useState } from 'react'
import { Link, NavLink, useLocation } from 'react-router-dom'
import {Menu, X, Mail} from 'lucide-react'

const navItems = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/industries', label: 'Industries' },
  { to: '/service-areas', label: 'Service Areas' },
  { to: '/contact', label: 'Contact' },
]

function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    onScroll()
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    setOpen(false)
  }, [location.pathname])

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 rounded-lg flex items-center justify-center relative overflow-hidden shadow-sm">
              <img
                src="https://static.lumi.new/45/453d999b1649f9653bad32d711e693eb.png"
                alt="Delta Facilities logo"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
            </div>
            <div className="flex flex-col">
              <span className="font-display text-navy text-lg font-bold leading-none">Delta</span>
              <span className="text-[10px] uppercase tracking-[0.2em] text-muted leading-none mt-1">Facilities</span>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-9">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `text-sm font-medium tracking-wide transition-colors link-underline ${
                    isActive ? 'text-orange-accent' : 'text-navy hover:text-orange-accent'
                  }`
                }
                end={item.to === '/'}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-5">
            <a
              href="mailto:info@deltafacilitiesservices.com"
              className="flex items-center gap-2 text-sm text-navy hover:text-orange-accent transition-colors"
            >
              <Mail className="w-4 h-4" />
              <span className="font-medium">info@deltafacilitiesservices.com</span>
            </a>
            <Link
              to="/quote"
              className="bg-orange-accent hover:bg-orange-dark text-white px-6 py-3 rounded-md text-sm font-semibold tracking-wide transition-all duration-300 shadow-sm hover:shadow-lg hover:-translate-y-0.5"
            >
              Request a Quote
            </Link>
          </div>

          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-navy"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-white border-t border-soft">
          <div className="px-6 py-6 space-y-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `block text-base font-medium py-2 ${
                    isActive ? 'text-orange-accent' : 'text-navy'
                  }`
                }
                end={item.to === '/'}
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/quote"
              className="block bg-orange-accent text-white px-6 py-3 rounded-md text-center font-semibold mt-4"
            >
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  )
}

export default Header
